<template>
    <div v-if="editor" class="editor">
        <menu-bar class="editor__header" :editor="editor" />
        <editor-content class="editor__content" :editor="editor" />
    </div>
</template>

<script setup lang="ts">
import { useEditor, EditorContent } from '@tiptap/vue-3'
import MenuBar from '@/components/html-editor/MenuBar.vue'
import Document from '@tiptap/extension-document'
import Paragraph from '@tiptap/extension-paragraph'
import Text from '@tiptap/extension-text'
import Link from '@tiptap/extension-link'
import Bold from '@tiptap/extension-bold'
import Italic from '@tiptap/extension-italic'
import Strike from '@tiptap/extension-strike'
import HardBreak from '@tiptap/extension-hard-break'
import BulletList from '@tiptap/extension-bullet-list'
import OrderedList from '@tiptap/extension-ordered-list'
import ListItem from '@tiptap/extension-list-item'
import Dropcursor from '@tiptap/extension-dropcursor'
import Gapcursor from '@tiptap/extension-gapcursor'
import { UndoRedo } from '@tiptap/extensions'

const modelValue = defineModel<string | null>('modelValue')

const emit = defineEmits<{
    (e: 'update:model-value', value: string | null | undefined): void
}>()

const editor = useEditor({
    content: modelValue.value,
    onUpdate: (value) => emit('update:model-value', value.editor.getHTML()),
    extensions: [
        Document,
        Paragraph,
        Text,
        Link,
        Bold,
        Italic,
        Strike,
        HardBreak,
        BulletList,
        OrderedList,
        ListItem,
        Dropcursor,
        Gapcursor,
        UndoRedo,
    ],
})
</script>

<style lang="scss" scoped>
.editor {
    display: flex;
    flex-direction: column;
    max-height: 400px;
    color: #212121;
    background-color: none;
    border: 1px solid rgb(148, 148, 148);
    margin-bottom: 1rem;

    &__header {
        display: flex;
        align-items: center;
        flex: 0 0 auto;
        flex-wrap: wrap;
        padding: 0.25rem;
        border-bottom: 1px solid rgb(148, 148, 148);
    }

    &__content {
      margin: 1rem !important;
        flex: 1 1 auto;
        overflow-x: hidden;
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
        :focus-visible {
            outline: 1px solid rgb(148, 148, 148) !important;
        }
    }
}
</style>
